import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Group } from '../models/group';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { getFileNameFromResponseContentDisposition, checkIfTruncated, saveFile } from './utils/file-download-helper';

@Injectable()
export class GroupService {

  GROUP_API_URL = environment.serverUrl + 'api/1/groups/';

  constructor(private httpClient: HttpClient) {
  }

  getPaginatedFilteredSortedGroups(pageIndex: number,
    itemPerPage: number,
    filters: Map<string, any>,
    criterias: Map<string, boolean>): Observable<any> {
    const url = this.getFormattedURL(pageIndex, itemPerPage, filters, criterias);
    return this.httpClient.get<any>(encodeURI(url), { observe: 'response' }).map(response => {
      return {
        headers: response.headers,
        res: <Group[]>response.body
      };
    });
  }

  downloadXLSFile(pageIndex: number, itemPerPage: number, filters: Map<string, any>, criterias: Map<string, boolean>): any {
    const url = this.getFormattedURL(pageIndex, itemPerPage, filters, criterias);
    return this.httpClient.get<any>(encodeURI(url), {
      headers: { Accept: 'application/octet-stream' },
      responseType: 'blob' as 'json',
      observe: 'response'
    }).map((response) => {
      const fileName = getFileNameFromResponseContentDisposition(response, 'groups.xls');
      const isTruncated = checkIfTruncated(response);
      saveFile(response.body.slice(), fileName);
      return isTruncated;
    });
  }

  getFormattedURL(pageIndex: number, itemPerPage: number, filters: Map<string, any>, criterias: Map<string, boolean>) {
    const offset = ((pageIndex - 1) * itemPerPage); // records offset to display the specific range
    let url = this.GROUP_API_URL + '?pagination=' + offset + '-' + itemPerPage + '&sorts=';

    if (criterias.size === 0) { // if no sorts criterias => sort by id
      url += 'g.name asc';
    } else {
      Array.from(criterias.keys()).forEach(c => url += c + (criterias.get(c) === true ? ' asc' : ' desc') + ',');
      url = url.substring(0, url.length - 1);
    }

    if (filters !== undefined) {

      const filtersAsString = JSON.stringify(filters, (key, value) => {
        if (value !== null && value !== undefined && value !== '') { return value; }
      });

      if (filtersAsString.length > 2) {
        url += '&filters=' + filtersAsString;
      }
    }

    return url;
  }

  post(g: Group): Observable<Group> {
    return this.httpClient.post<Group>(encodeURI(this.GROUP_API_URL), g);
  }

  update(g: Group): Observable<Group> {
    return this.httpClient.put<Group>(encodeURI(this.GROUP_API_URL + g.id), g);
  }

  loadVisibleGroups(): Observable<Group[]> {
    return this.httpClient.get<Group[]>(encodeURI(this.GROUP_API_URL + '?pagination=0-100'));
  }

  get(id: number): Observable<Group> {
    return this.httpClient.get<Group>(encodeURI(this.GROUP_API_URL + id));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(encodeURI(this.GROUP_API_URL + id));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/group.service.ts